/**
 * 使用ページ確認アウトプット用VOクラス
 *
 * @export KYMW0E00OutputModel
 * @class KYMW0E00OutputModel
 */
export class KYMW0E00OutputModel {

  // 変更確認(1：変更OK、2：キャンセル)
  public changeButton = Number(0);

  // 処理区分(1:使用範囲変更時,2:使用停止時,3:削除時)
  public processDiv = Number(0);

  /**
   * コンストラクタ
   */
  constructor() { }
}
